var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-container"},[_c('iframe',{staticClass:"custom-iframe",attrs:{"src":"https://10.1.134.35:8000/","title":"Iframe Example"}})])
}]

export { render, staticRenderFns }